@if (active$ | async) {
    <app-wizard-step [title]="title" data-test="step-load-master-data">
        <app-load-master-data>
            <priva-notification status="Success" data-test="confirmation-master-data-loaded"
                >{{ 'SETUP.STEP_4.SUCCESS_LOAD' | translate }}
            </priva-notification>
        </app-load-master-data>
    </app-wizard-step>
}
